"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const contact_1 = require("./contact");
const incomingOrder_1 = require("./incomingOrder");
const shipment_1 = require("./shipment");
const tracking_1 = require("./tracking");
const user_1 = require("./user");
const vehicle_1 = require("./vehicle");
const news_1 = require("./news");
const selectedColumns_1 = require("./selectedColumns");
const email_1 = require("./email");
const bankAccount_1 = require("./bankAccount");
const outcomingOrder_1 = require("./outcomingOrder");
const file_1 = require("./file");
const DEFAULT_AXIOS_INSTANCE = axios_1.default.create({
    headers: {
        "X-Cargotic-API-Client": "Cargotic API Client"
    }
});
const createClient = (axios = DEFAULT_AXIOS_INSTANCE) => ({
    contact: contact_1.createContactClient(axios),
    incomingOrder: incomingOrder_1.createIncomingOrderClient(axios),
    outcomingOrder: outcomingOrder_1.createOutcomingOrderClient(axios),
    shipment: shipment_1.createShipmentClient(axios),
    tracking: tracking_1.createTrackingClient(axios),
    user: user_1.createUserClient(axios),
    vehicle: vehicle_1.createVehicleClient(axios),
    news: news_1.createNewsClient(axios),
    selectedColumns: selectedColumns_1.createSelectedColumnsClient(axios),
    email: email_1.createEmailClient(axios),
    bankAccount: bankAccount_1.createBankAccountClient(axios),
    file: file_1.createFileClient(axios)
});
exports.default = createClient;
